module.exports = __webpack_public_path__ + "static/media/sigma.a0814a2d.svg";